import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import { auth } from '../../client/firebase';

export class MedqContentProviderClient {
  private readonly axiosClient: AxiosInstance;

  constructor(config: {
    endpoint?: string;
  }) {
    this.axiosClient = axios.create({
      baseURL: config.endpoint,
    });
    this.createRefreshTokenInterceptor();
  }

  async getQuestionsGroupedBySubject(institutionName: string, subjectDepth: number): Promise<
  GetQuestionsGroupedBySubjectResponse> {
    const result = await this.axiosClient.get<GetQuestionsGroupedBySubjectResponse>(
      `/public/questions/questions-grouped-by-subjects?institutionName=${institutionName}&subjectDepth=${subjectDepth}`,
    );
    return result.data;
  }

  private async getToken(): Promise<string> {
    const { currentUser } = auth;
    const res = await currentUser?.getIdToken();
    return res || '';
  }

  private createRefreshTokenInterceptor(): void {
    this.axiosClient.interceptors.request.use(async (request: AxiosRequestConfig) => {
      const token = await this.getToken();
      request.headers.Authorization = `Bearer ${token}`;
      return request;
    });
  }
}

export const DifficultyNameValues = [
  'unknown',
  'easy',
  'hard',
  'medium',
] as const;
export type DifficultyName = typeof DifficultyNameValues[number];

export type GetQuestionsGroupedBySubjectResponse = {
  status: 'success';
  questions: {
    subjectId: string;
    ancestors: string[];
    questions: {
      questionId: string;
      subjectId?: string;
      subjectAccumulatedNames?: string[];
      body: string;
      answers: AnswerInfo[];
      examIndex: number;
      examYear: number;
      examType: string;
      institutionId: string;
      institutionName: string;
      difficultyName: DifficultyName;
      examId: string;
      isCanceled: boolean;
    }[];
    questionCount: number;
    difficulty: number;
  }[];
};

type AnswerInfo = {
  body: string;
  isCorrect: boolean;
  answeredCount: number;
};
